<template>
    <div>

        <h5>
            גוגל
        </h5>

        <div>



            <!-- <div class="mb-3">
                חשבון גוגל מחובר:
                {{ googleUserData.email }}
            </div> -->

            <div class="row">
                <div class="col-4">
                    <div class="mb-3">
                        <label class="form-label">
                            יומן לסינכרון
                            (להזין כותבת
                            Gmail
                            )
                        </label>
                        <!-- <Multiselect v-model="googleChosenCalendar"
                                     label="summary"
                                     track-by="id"
                                     deselect-label=""
                                     placeholder="היומנים שלכם"
                                     selectLabel=""
                                     :options="googleCalendarList"></Multiselect> -->

                        <input class="form-control"
                               type="text"
                               v-model="googleChosenCalendarId">

                    </div>
                </div>
                <div class="col-4">
                    <div class="mb-3">
                        <label class="form-label">
                            סוג סנכרון
                        </label>
                        <Multiselect v-model="googleCalendarSyncDirection"
                                     deselect-label=" "
                                     label="label"
                                     track-by="value"
                                     placeholder="בחרו סוג סנכרון"
                                     selectLabel=""
                                     selectedLabel=""
                                     :options="syncOptionsList">
                            <template slot="noResult">לא נמצאו תוצאות</template>
                            <template slot="noOptions">אין אפשרויות</template>
                        </Multiselect>

                    </div>
                </div>

            </div>


            <div>

                <span style="color:red">
                    שימו לב!

                </span>
                <br>

                על מנת לסנכרן את היומנים יש לתת גישה ליומן לפי


                <span style="color:#ab8ce4;cursor:pointer"
                      @click="$refs.instructions.show()">
                    ההוראות</span>.





            </div>


            <br>


            <div>

                <label style="user-select: none;cursor:pointer"
                       @click="googleExportAsWholeDay = !googleExportAsWholeDay">


                    <span style="position:relative;top:1px;"
                          class="planup-checkbox planup-checkbox-purple"
                          :class="{ checked: googleExportAsWholeDay }">
                        <i class="fa fa-check"></i>
                    </span>


                    ייצוא אירועים כיום שלם
                    (יופיעו בראשית היום ולא בשעה ספציפית)
                </label>

            </div>

            <div>

                <label style="user-select: none;cursor:pointer"
                       @click="showPriceOnGoogleCalendar = !showPriceOnGoogleCalendar">


                    <span style="position:relative;top:1px;"
                          class="planup-checkbox planup-checkbox-purple"
                          :class="{ checked: showPriceOnGoogleCalendar }">
                        <i class="fa fa-check"></i>
                    </span>


                    הצגת מחיר באירועים ביומן גוגל
                </label>

            </div>


            <br>

            <div class="row">
                <div class="col-4">
                    <div class="mb-3">
                        <label class="form-label">
                            משך אירוע ביומן גוגל
                        </label>
                        <Multiselect v-model="googleCalendarEventDurationHours"
                                     deselect-label=" "
                                     label="label"
                                     track-by="value"
                                     placeholder="בחרו משך אירוע"
                                     selectLabel=""
                                     selectedLabel=""
                                     :options="eventDurationOptions">
                            <template slot="noResult">לא נמצאו תוצאות</template>
                            <template slot="noOptions">אין אפשרויות</template>
                        </Multiselect>
                    </div>
                </div>
            </div>

            <br>

            <div class="pull-right">

                <!-- <button class="btn btn-danger"
        @click="connectGoogleCalendar()">
    <i class="fa-brands fa-google"></i>
    &nbsp;
    החלפת חשבון
</button> -->

                <button class="btn btn-light"
                        @click="$refs.cleanupGoogleCalendar.show()">
                    &nbsp;
                    ניקוי ועדכון יומן
                </button>

                &nbsp;
                <button class="btn btn-outline-primary"
                        @click="saveSettingsOnly()">
                    &nbsp;
                    שמירה בלבד
                </button>

                &nbsp;
                <button class="btn btn-primary"
                        @click="saveCalendarSync()">
                    &nbsp;
                    החל סנכרון
                </button>





            </div>
            <br>
            <br>
            <br>
            <br>
            <br>
            <br>
            <div style="clear:both">

            </div>




            <div class="row">
                <div class="col-4">

                    <div class="mb-2">
                        פורמט אירועים
                    </div>


                    <Multiselect v-model="googleEventFormat"
                                 deselect-label=""
                                 label="label"
                                 track-by="value"
                                 placeholder=""
                                 selectLabel=""
                                 selectedLabel=""
                                 :multiple="true"
                                 :allow-empty="true"
                                 :showNoOptions="false"
                                 :options="eventNameParts"
                                 :taggable="false">
                        <template slot="noResult">לא נמצאו תוצאות</template>
                    </Multiselect>

                    <br>
                    כדי לראות שינויים באירועים שכבר נמצאים ביומן יש ללחוץ על כפתור ניקוי ועדכון יומן.








                </div>

                <div class="col-8"
                     style="text-align: center;width:600px;margin:0 auto;">
 
                    תצוגה מקדימה
                    
                    <br>
                    <div class="mb-2"></div>

                    <div
                         style="vertical-align: top; width:33%;height:200px;border: solid 1px #dde3ea;padding: 5px;display:inline-block;text-align: right;border-left:none;">
                        <div style="text-align: center;font-weight:bold;">
                            7
                        </div>
                        <br>

                    </div>
                    <div
                         style="vertical-align: top;width:33%;height:200px;border: solid 1px #dde3ea;padding: 5px;display:inline-block;text-align: right;border-left:none;">
                        <div style="text-align: center;font-weight:bold;">
                            6
                        </div>
                        <br>
                        <div v-if="googleExportAsWholeDay"
                             style="border-radius:3px;background:#ddbde6;margin-bottom:5px;padding:3px;padding-right:10px;">

                            <div v-html="googleEventFormatPreview"
                                 style="color:777 !important">
                            </div>
                        </div>
                        <div v-else
                             style="color:777 !important">
                            <i class="fa-solid fa-circle"
                               style="color:#ddbde6;font-size:8px;position:relative;top:-2px;"></i>
                            19:00
                            &nbsp;
                            <span v-html="googleEventFormatPreview"></span>
                        </div>

                    </div>
                    <div
                         style="vertical-align: top;width:33%;height:200px;border: solid 1px #dde3ea;padding: 5px;display:inline-block;text-align: right;">
                        <div style="text-align: center;font-weight:bold;">
                            5
                        </div>
                        <br>

                    </div>

                </div>



                <br>
                <br>






            </div>


            <br>
            <br>


            <div class="row">
                <div class="col-4">

                    <div class="mb-2">
                        פורמט פגישות
                    </div>


                    <Multiselect v-model="googleMeetingFormat"
                                 deselect-label=""
                                 label="label"
                                 track-by="value"
                                 placeholder=""
                                 selectLabel=""
                                 selectedLabel=""
                                 :multiple="true"
                                 :allow-empty="true"
                                 :showNoOptions="false"
                                 :options="meetingNameParts"
                                 :taggable="false">
                        <template slot="noResult">לא נמצאו תוצאות</template>
                    </Multiselect>

                    <br>
                    כדי לראות שינויים בפגישות שכבר נמצאות ביומן יש ללחוץ על כפתור ניקוי ועדכון יומן.








                </div>

                <div class="col-8"
                     style="text-align: center;width:600px;margin:0 auto;">

                    תצוגה מקדימה
                    <br>
                    <div class="mb-2"></div>

                    <div
                         style="vertical-align: top; width:33%;height:200px;border: solid 1px #dde3ea;padding: 5px;display:inline-block;text-align: right;border-left:none;">
                        <div style="text-align: center;font-weight:bold;">
                            7
                        </div>
                        <br>

                    </div>
                    <div
                         style="vertical-align: top;width:33%;height:200px;border: solid 1px #dde3ea;padding: 5px;display:inline-block;text-align: right;border-left:none;">
                        <div style="text-align: center;font-weight:bold;">
                            6
                        </div>
                        <br>
                        <div style="color:777 !important">
                            <i class="fa-solid fa-circle"
                               style="color:rgb(194, 233, 215);font-size:8px;position:relative;top:-2px;"></i>
                            19:00
                            &nbsp;
                            <span v-html="googleMeetingFormatPreview"></span>
                        </div>

                    </div>
                    <div
                         style="vertical-align: top;width:33%;height:200px;border: solid 1px #dde3ea;padding: 5px;display:inline-block;text-align: right;">
                        <div style="text-align: center;font-weight:bold;">
                            5
                        </div>
                        <br>

                    </div>

                </div>



                <br>
                <br>






            </div>

            <br>
            <br>

            <div class="pull-right">
                <button class="btn btn-primary"
                        @click="saveFormatStrings()">
                    שמור פורמטים
                </button>

            </div>






        </div>
        <!-- <div v-else>
            <button class="btn btn-danger"
                    @click="connectGoogleCalendar()">
                <i class="fa-brands fa-google"></i>
                &nbsp;
                חיבור חשבון גוגל
            </button>
        </div> -->



        <Modal title="ניקוי ועדכון יומן"
               ref="cleanupGoogleCalendar"
               :hideFooter="true">

            <template v-slot:body>
                <div>
                    הפעולה הזו תוודא שיומן גוגל מותאם בדיוק לנתונים שמוזנים במערכת.
                </div>

                <br>

                <div style="width:80%;margin:0 auto;">

                    <Multiselect label="label"
                                 selected-label=" "
                                 select-label=" "
                                 deselect-label=" "
                                 placeholder=" "
                                 :allow-empty="false"
                                 :showNoOptions="false"
                                 track-by="value"
                                 v-model="chosenCleanupCalendar"
                                 :options="cleanupCalendarList">

                        <template slot="noResult">לא נמצאו תוצאות</template>
                    </Multiselect>
                </div>

                <br>
                <br>

                <div class="pull-right">

                    <button class="btn btn-light"
                            @click="$refs.cleanupGoogleCalendar.hide()">
                        ביטול
                    </button>

                    &nbsp;

                    <button class="btn btn-primary"
                            @click="cleanupGoogleCalendar()">
                        בצע
                    </button>


                </div>



            </template>

        </Modal>






        <Modal title="הוראות לביצוע סנכרון יומן גוגל"
               ref="instructions"
               :hideFooter="true">
            <template v-slot:body>


                <div>

                    עבור כל יומן גוגל יש לבצע את הפעולות הבאות:

                    <br>
                    <br>

                    <ol>
                        <li>
                            היכסנו ליומן גוגל
                            <br>
                            <br>
                        </li>
                        <li>
                            לחצו על כפתור 3 נקודות ליד היומן הרצוי
                            <br>
                            <br>
                            <img src="https://planup-il.s3.eu-central-1.amazonaws.com/google_sync_1.png"
                                 style="width:300px; margin: 0 auto;display: block">
                            <br>
                            <br>
                        </li>
                        <li>
                            בחרו "הגדרות ושיתוף"
                            <br>
                            <br>
                            <img src="https://planup-il.s3.eu-central-1.amazonaws.com/google_sync_2.png"
                                 style="width:300px; margin: 0 auto;display: block">
                            <br>
                            <br>
                        </li>
                        <li>
                            מצאו את הכותרת "שיתוף עם אנשים ספציפיים או קבוצות ספציפיות" ולחצו על הכפתור "הוספת אנשים
                            וקבוצות"
                            <br>
                            <br>
                            <img src="https://planup-il.s3.eu-central-1.amazonaws.com/google_sync_3.png"
                                 style="width:300px; margin: 0 auto;display: block">
                            <br>
                            <br>
                        </li>
                        <li>
                            הזינו את כתובת המייל הבאה:

                            <br>
                            <span style="font-weight:bold;">
                                planup@planup-397905.iam.gserviceaccount.com
                            </span>
                            <button class="btn btn-primary btn-xs"
                                    @click="copyServiceAccount">



                                <span v-if="copiedServiceAccount">

                                    <i class="fa-solid fa-check"></i>
                                    הועתק
                                </span>
                                <span v-else>
                                    העתק
                                </span>







                            </button>

                            <br>
                            <br>
                            <img src="https://planup-il.s3.eu-central-1.amazonaws.com/google_sync_4.png"
                                 style="width:300px; margin: 0 auto;display: block">
                            <br>
                            <br>
                        </li>
                        <li>

                            תחת הרשאות בחרו באפשרות

                            "לשנות אירועים"

                            <br>
                            <br>
                            <img src="https://planup-il.s3.eu-central-1.amazonaws.com/google_sync_5.png"
                                 style="width:300px; margin: 0 auto;display: block">
                            <br>
                            <br>
                        </li>
                        <li>
                            לחצו על שליחה על מנת לשמור
                        </li>
                    </ol>

                </div>

            </template>
        </Modal>

    </div>
</template>
<script>

import Multiselect from 'vue-multiselect';
import Config from '../../Config'
import axiosV2, { apiPost } from '../../core/http/axios_api_v2'



export default {
    name: 'GoogleData',
    data() {

        return {

            eventNameParts: [

                {
                    value: 'name',
                    label: 'שם האירוע'
                },
                {
                    value: 'place',
                    label: 'מקום האירוע'
                },
                {
                    value: 'systemStatus',
                    label: 'סטטוס'
                },
                {
                    value: 'crew',
                    label: 'צוות'
                },
                {
                    value: 'weekday',
                    label: 'יום האירוע בשבוע'
                },
                {
                    value: 'eventClass',
                    label: 'סוג האירוע'
                },
                {
                    value: 'time',
                    label: 'שעת האירוע'
                },
                {
                    value: 'guests',
                    label: 'מספר אורחים'
                },
                {
                    value: 'contacts',
                    label: 'שם הלקוח'
                },
                {
                    value: 'phone',
                    label: 'טלפון הלקוח'
                },
                // {
                //     value: 'otherVendors',
                //     label: 'ספקים נוספים'
                // }

            ],

            meetingNameParts: [

                {
                    value: 'name',
                    label: 'שם הפגישה'
                },
                {
                    value: 'meetingType',
                    label: 'סוג הפגישה'
                },
                {
                    value: 'place',
                    label: 'מקום הפגישה'
                },
                {
                    value: 'crew',
                    label: 'צוות הפגישה'
                },
                {
                    value: 'weekday',
                    label: 'יום הפגישה בשבוע'
                },
                {
                    value: 'contacts',
                    label: 'שם הלקוח'
                },
                {
                    value: 'phone',
                    label: 'טלפון הלקוח'
                },
                {
                    value: 'eventName',
                    label: 'שם האירוע'
                },
                {
                    value: 'eventClass',
                    label: 'סוג האירוע'
                },
                {
                    value: 'eventPlace',
                    label: 'מקום האירוע'
                },
                {
                    value: 'eventCrew',
                    label: 'צוות האירוע'
                },
                {
                    value: 'eventDate',
                    label: 'תאריך האירוע'
                },
                {
                    value: 'eventWeekday',
                    label: 'יום האירוע בשבוע'
                },
                {
                    value: 'eventGuests',
                    label: 'מספר אורחים באירוע'
                }

            ],

            googleEventFormat: [],
            googleMeetingFormat: [],
            chosenCleanupCalendar: null,
            cleanupCalendarList: [],
            copiedServiceAccount: false,
            syncOptionsList: [

                {
                    label: 'ללא סנכרון',
                    value: 'none'
                },
                {
                    label: 'מפלנאפ לגוגל בלבד',
                    value: 'planup2google'
                },
                {
                    label: 'מגוגל לפלנאפ בלבד',
                    value: 'google2planup'
                },
                {
                    label: 'סנכרון דו כיווני',
                    value: 'both'
                }],
            googleCalendarSyncDirection: '',
            googleChosenCalendarId: null,
            googleExportAsWholeDay: false,
            googleCalendarEventDurationHours: null,
            showPriceOnGoogleCalendar: true,
            eventDurationOptions: [
                { value: 1, label: 'שעה אחת' },
                { value: 2, label: '2 שעות' },
                { value: 3, label: '3 שעות' },
                { value: 4, label: '4 שעות' },
                { value: 5, label: '5 שעות' },
                { value: 6, label: '6 שעות' },
                { value: 8, label: '8 שעות' },
                { value: 12, label: '12 שעות' }
            ],
            // googleUserData: null,
            // googleCalendarList: []
        };
    },
    computed: {
        googleEventFormatPreview() {

            if (!this.googleEventFormat.length)
                return 'נא להזין פורמט';

            return this.googleEventFormat.map(part => part.label).join(' - ');
        },
        googleMeetingFormatPreview() {

            if (!this.googleMeetingFormat.length)
                return 'נא להזין פורמט';

            return this.googleMeetingFormat.map(part => part.label).join(' - ');
        }
    },
    mounted() {


        if (!this.$store.state.businessSettings.formatForGoogleEventSummary) {

            this.googleEventFormat.push(this.eventNameParts.find(part => part.value == 'name'))
            this.googleEventFormat.push(this.eventNameParts.find(part => part.value == 'place'))
            this.googleEventFormat.push(this.eventNameParts.find(part => part.value == 'systemStatus'));

        } else {

            this.$store.state.businessSettings.formatForGoogleEventSummary.split(' ').forEach(part => {
                this.googleEventFormat.push(this.eventNameParts.find(p => p.value == part));
            });

        }


        if (!this.$store.state.businessSettings.formatForGoogleMeetingSummary) {

            this.googleMeetingFormat.push(this.meetingNameParts.find(part => part.value == 'name'))
            this.googleMeetingFormat.push(this.meetingNameParts.find(part => part.value == 'place'))

        } else {

            this.$store.state.businessSettings.formatForGoogleMeetingSummary.split(' ').forEach(part => {
                this.googleMeetingFormat.push(this.meetingNameParts.find(p => p.value == part));
            });

        }

        // this.handleAccessTokenFlow();
        this.getGoogleData();
    },
    methods: {


        saveFormatStrings() {

            let formatForGoogleEventSummary = this.googleEventFormat.map(part => part.value).join(' ');
            let formatForGoogleMeetingSummary = this.googleMeetingFormat.map(part => part.value).join(' ');

            apiPost('business-settings/saveGoogleFormatStrings', { formatForGoogleEventSummary, formatForGoogleMeetingSummary });
        },

        copyServiceAccount() {


            this.$window.navigator.clipboard.writeText('planup@planup-397905.iam.gserviceaccount.com').then(() => {
                this.copiedServiceAccount = true;
                setTimeout(() => {
                    this.copiedServiceAccount = false;
                }, 1000);
            });
        },

        saveSettingsOnly() {
            var calendarSyncParams = {
                googleChosenCalendarId: this.googleChosenCalendarId,
                googleCalendarSyncDirection: this.googleCalendarSyncDirection.value,
                googleExportAsWholeDay: this.googleExportAsWholeDay,
                googleCalendarEventDurationHours: this.googleCalendarEventDurationHours ? this.googleCalendarEventDurationHours.value : 1,
                showPriceOnGoogleCalendar: this.showPriceOnGoogleCalendar,
                syncNow: false
            };

            apiPost('google-api/saveGoogleSyncOptions', calendarSyncParams).then(function() {
                this.$swal({
                    type: 'success',
                    title: 'ההגדרות נשמרו בהצלחה',
                    confirmButtonText: 'אישור',
                    confirmButtonColor: '#ab8ce4'
                });
            }.bind(this));
        },

        saveCalendarSync() {


            let calendarSyncParams = {
                googleChosenCalendarId: this.googleChosenCalendarId,
                googleCalendarSyncDirection: this.googleCalendarSyncDirection.value,
                googleExportAsWholeDay: this.googleExportAsWholeDay,
                googleCalendarEventDurationHours: this.googleCalendarEventDurationHours ? this.googleCalendarEventDurationHours.value : 1,
                showPriceOnGoogleCalendar: this.showPriceOnGoogleCalendar
            }



            this.$swal({
                title: 'האם לבצע סנכרון ראשוני עכשיו?',
                text: 'שימו לב - אם החשבונות כבר מסונכרנים, עלולים להיווצר כפילויות.',
                confirmButtonText: 'סנכרן עכשיו',
                cancelButtonText: 'שמור הגדרות בלבד',
                confirmButtonColor: '#ab8ce4',
                showCancelButton: true,

            }).then(result => {

                calendarSyncParams.syncNow = true;

                apiPost('google-api/saveGoogleSyncOptions', calendarSyncParams)

            }).catch(error => {

                apiPost('google-api/saveGoogleSyncOptions', calendarSyncParams)


            })




        },


        cleanupGoogleCalendar() {
            apiPost(`google-mega-sync?crewMemberId=${this.chosenCleanupCalendar.value}`);
            this.$refs.cleanupGoogleCalendar.hide();
        },

        openSyncDirectionModal() {
            this.$refs.syncDirectionModal.show();
        },
        // handleAccessTokenFlow() {
        //     if (this.$store.state._alertConnectGoogleSuccess) {
        //         this.$swal({
        //             type: 'success',
        //             title: 'חשבון גוגל מחובר בהצלחה!',
        //             confirmButtonText: 'המשך',
        //             confirmButtonColor: '#ab8ce4'
        //         });
        //         delete this.$store.state._alertConnectGoogleSuccess;
        //         return;
        //     }
        //     let accessTokenMatch = window.location.href.match(/&access_token=(.*?)&/);
        //     if (!accessTokenMatch)
        //         return;
        //     axios.post('google-api/saveGoogleParams', { accessToken: accessTokenMatch[1] }).then((response) => {
        //         this.$router.push('/settings?activeTab=orginizationSettings_googleTab');
        //         this.$store.state._alertConnectGoogleSuccess = 1;
        //     });
        // },
        getGoogleData() {

            let that = this;
            axiosV2('google-api/getGoogleData').then(response => {
                // this.googleUserData = response.data?.googleUserData;
                // this.googleCalendarList = response.data?.googleCalendarList ? response.data?.googleCalendarList : [] ;
                // this.googleChosenCalendar = this.googleCalendarList.find(c => c.id == response.data.googleChosenCalendarId)

                this.googleChosenCalendarId = response.data?.googleChosenCalendarId;
                this.googleCalendarSyncDirection = response.data?.googleCalendarSyncDirection ? that.syncOptionsList.find(direction => direction.value == response.data?.googleCalendarSyncDirection) : that.syncOptionsList[0];
                this.googleExportAsWholeDay = response.data?.googleExportAsWholeDay;
                this.showPriceOnGoogleCalendar = response.data?.showPriceOnGoogleCalendar !== false;

                var durationHours = response.data?.googleCalendarEventDurationHours || 1;
                this.googleCalendarEventDurationHours = this.eventDurationOptions.find(function(opt) { return opt.value == durationHours; }) || this.eventDurationOptions[0];

                this.cleanupCalendarList = this.$store.state.crewMembers.filter(cm => cm.email).map(cm => { return { value: cm.id, label: `${cm.name} (${cm.email})` } });
                this.cleanupCalendarList.unshift({ value: 0, label: `יומן ראשי (${this.googleChosenCalendarId})` });

            });
        },
        // connectGoogleCalendar() {


        //     console.log('Redirect URI:');
        //     console.log(`${Config.SETTINGS.APP_URL}settings?activeTab=orginizationSettings_googleTab`);

        //     // Google's OAuth 2.0 endpoint for requesting an access token
        //     var oauth2Endpoint = 'https://accounts.google.com/o/oauth2/v2/auth';
        //     // Create <form> element to submit parameters to OAuth 2.0 endpoint.
        //     var form = document.createElement('form');
        //     form.setAttribute('method', 'GET'); // Send as a GET request.
        //     form.setAttribute('action', oauth2Endpoint);
        //     // Parameters to pass to OAuth 2.0 endpoint.
        //     var params = {
        //         'client_id': '340965126822-psnjm1h1h26c5lgcreik4vjg39seepoo.apps.googleusercontent.com',
        //         'redirect_uri': `${Config.SETTINGS.APP_URL}settings?activeTab=orginizationSettings_googleTab`,
        //         'response_type': 'token',
        //         'scope': 'https://www.googleapis.com/auth/userinfo.email  https://www.googleapis.com/auth/userinfo.profile  https://www.googleapis.com/auth/calendar.calendarlist  https://www.googleapis.com/auth/calendar.events.readonly  https://www.googleapis.com/auth/calendar.events.owned',
        //         'include_granted_scopes': 'true',
        //         'state': 'pass-through value'
        //     };
        //     // Add form parameters as hidden input values.
        //     for (var p in params) {
        //         var input = document.createElement('input');
        //         input.setAttribute('type', 'hidden');
        //         input.setAttribute('name', p);
        //         input.setAttribute('value', params[p]);
        //         form.appendChild(input);
        //     }
        //     // Add form to page and submit it to open the OAuth 2.0 endpoint.
        //     document.body.appendChild(form);
        //     form.submit();
        // }
    },
    components: { Multiselect }
}
</script>